import {NotificationModel} from '@domain-group/realhub-backend-api-types'

const state = {
  id: null,
  audience: '',
  body: '',
  end_date: '',
  link: '',
  notifiable_id: undefined,
  notifiable_type: '',
  options: {
    dismissable: true,
  },
  start_date: '',
  title: '',
}

export const requiredFields = [
  { key: 'audience' },
  { key: 'body' },
  {
    key: 'end_date',
    validation: (value: string, entityState: NotificationModel) => (entityState.start_date ? !!value : true),
  },
  {
    key: 'options.primary_link_title',
    validation: (value: string, entityState: NotificationModel) => (
      entityState.options?.primary_link_url ? !!value : true
    ),
  },
  {
    key: 'options.primary_link_url',
    validation: (value: string, entityState: NotificationModel) => (
      entityState.options?.primary_link_title ? !!value : true
    ),
  },
  {
    key: 'options.secondary_link_title',
    validation: (value: string, entityState: NotificationModel) => (
      entityState.options?.secondary_link_url ? !!value : true
    ),
  },
  {
    key: 'options.secondary_link_url',
    validation: (value: string, entityState: NotificationModel) => (
      entityState.options?.secondary_link_title ? !!value : true
    ),
  },
  {
    key: 'start_date',
    validation: (value: string, entityState: NotificationModel) => (entityState.end_date ? !!value : true),
  },
  { key: 'title' },
]

export default state
